const normalizeId = (value) => {
  if (value == null) return "";
  const normalized = String(value).trim();
  return normalized;
};

export const hasCourseSkillsRoute = (pathname = "") =>
  pathname.startsWith("/composer/courses/") && pathname.includes("/skills");

export const hasCourseSkillGroupsRoute = (pathname = "") =>
  pathname.startsWith("/composer/courses/") && pathname.includes("/skill-groups");

export const isSkillsRoutePath = (pathname = "") =>
  hasCourseSkillsRoute(pathname) || hasCourseSkillGroupsRoute(pathname);

export const buildCourseSkillsPath = (courseId) =>
  `/composer/courses/${encodeURIComponent(normalizeId(courseId))}/skills`;

export const buildCourseSkillNewPath = (courseId, parentId) => {
  const params = new URLSearchParams();
  const normalizedParentId = normalizeId(parentId);
  if (normalizedParentId) {
    params.set("parentId", normalizedParentId);
  }
  const search = params.toString();
  const path = `${buildCourseSkillsPath(courseId)}/new`;
  return search ? `${path}?${search}` : path;
};

export const buildCourseSkillEditPath = (courseId, skillId) =>
  `${buildCourseSkillsPath(courseId)}/${encodeURIComponent(normalizeId(skillId))}/edit`;

export const buildCourseSkillGroupNewPath = (courseId) =>
  `/composer/courses/${encodeURIComponent(normalizeId(courseId))}/skill-groups/new`;

export const buildCourseSkillGroupEditPath = (courseId, groupId) =>
  `/composer/courses/${encodeURIComponent(normalizeId(courseId))}/skill-groups/${encodeURIComponent(normalizeId(groupId))}/edit`;
